import { useMemo } from "react";

import {
  useProductOutput,
  useTechnicalDesignInputMode,
  type OrderCodePartOption,
  type OrderCodePart,
  TechnicalDesignInputModes,
} from "stores/product";

export const useIsPartOptionDisabled = (
  part: OrderCodePart,
  option: OrderCodePartOption,
) => {
  const technicalDesignInputMode = useTechnicalDesignInputMode();
  const productOutput = useProductOutput();

  const iterablePartsSet = useMemo(() => {
    const iterableParts =
      productOutput?.product?.listViewConfiguration?.iterableParts;
    if (iterableParts === null || iterableParts === undefined) {
      return new Set<string>();
    }
    return new Set(
      iterableParts.flatMap(
        (p) => p?.options?.map((o) => `${p.partKey}-${o?.optionKey}`) ?? [],
      ),
    );
  }, [productOutput]);

  const isDisabled = useMemo(() => {
    if (technicalDesignInputMode === TechnicalDesignInputModes.RESULT_LIST) {
      return iterablePartsSet.has(`${part.key}-${option.key}`);
    }
    return false;
  }, [iterablePartsSet, part.key, option.key, technicalDesignInputMode]);

  return isDisabled;
};
